import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import Contact from '@repo/utils/models/Contact';
import analytics from '@repo/utils/helpers/analytics';

function handleClick(contact: Contact) {
  analytics.track('Contact Social Tapped', { contactId: contact.objectID });
}

export function ContactWebsites({ contact, underline = true }) {
  if (!contact.websites || contact.websites.length === 0) {
    return null;
  }

  const validWebsites = contact.websites
    .filter(({ url }) => !!url)
    .map((item) => ({
      ...item,
      href: item.url.includes('http') ? item.url : `http://${item.url}`,
    }));

  if (validWebsites.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle underline={underline}>Websites</SectionTitle>
      {validWebsites.map((item, i) => (
        <div key={i}>
          <a onClick={handleClick.bind(null, contact)} href={item.href} target="_blank">
            {item.url.trim()}
          </a>
        </div>
      ))}
    </Section>
  );
}
